<!-- 物流运输单顶端部分 -->
<template>
  <div class="baseForm">
    <el-form
      :model="baseData"
      :rules="baseDataRules"
      ref="baseForm"
      label-width="120px"
      :disabled="status == '3' || status == '4'"
    >
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.instructionNo')"
            prop="instructionNo"
          >
            <el-select
              :disabled="insDis"
              clearable
              @change="changeDeliveryType"
              class="widthStyle"
              v-model="baseData.instructionNo"
              filterable
              remote
              reserve-keyword
              :placeholder="this.$t('transportOrderAdd.baseForm.instructionNoPlaceholder')"
              :remote-method="instructionNoRemote"
              :loading="instructionNoLoading"
            >
              <el-option
                v-for="(item, index) in instructionNoOptions"
                :key="index"
                :label="item.instructionNo"
                :value="item.instructionNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.salesLadingNo')"
            prop="salesLadingNo"
          >
            <el-select
              :disabled="salesDis"
              clearable
              @change="changeDeliveryType"
              class="widthStyle"
              v-model="baseData.salesLadingNo"
              filterable
              remote
              reserve-keyword
              :placeholder="this.$t('transportOrderAdd.baseForm.salesLadingNoPlaceholder')"
              :remote-method="salesLadingNoRemote"
              :loading="salesLadingNoLoading"
            >
              <el-option
                v-for="item in salesLadingNoOptions"
                :key="item.ladingNo"
                :label="item.ladingNo"
                :value="item.ladingNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.transferSlipNo')"
            prop="transferSlipNo"
            :required="isTransferSlipNo"
          >
            <el-select
              :disabled="transDis"
              clearable
              @change="changeDeliveryType"
              class="widthStyle"
              v-model="baseData.transferSlipNo"
              filterable
              remote
              reserve-keyword
              :placeholder="this.$t('transportOrderAdd.baseForm.transferSlipNoPlaceholder')"
              :remote-method="transferSlipNoRemote"
              :loading="transferSlipNoLoading"
            >
              <el-option
                v-for="(item, index) in transferSlipNoOptions"
                :key="index"
                :label="item.allotNo"
                :value="item.allotNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.otherNo')"
            prop="otherNo"
            :required="isOtherNo"
          >
            <el-select
              :disabled="otherDis"
              clearable
              @change="changeDeliveryType"
              class="widthStyle"
              v-model="baseData.otherNo"
              filterable
              remote
              reserve-keyword
              :placeholder="this.$t('transportOrderAdd.baseForm.otherNoPlaceholder')"
              :remote-method="otherNoRemote"
              :loading="otherNoLoading"
            >
              <el-option
                v-for="(item, index) in otherNoOptions"
                :key="index"
                :label="item.returnNo"
                :value="item.returnNo"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item :label="this.$t('transportOrderAdd.baseForm.pickupNo')" prop="pickupNo">
            <el-input
              :placeholder="this.$t('transportOrderAdd.baseForm.pickupNoPlaceholder')"
              v-model="baseData.pickupNo"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.providerName')"
            prop="providerName"
          >
            <search-table
              v-model="baseData.providerName"
              searchType="supplier"
              :currentValue="baseData.providerName || null"
              :checkRowKeys="[baseData.providerNo]"
              @input="setProviderName"
              :isMultiple="true"
            ></search-table>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.salesmanName')"
            prop="salesmanName"
          >
            <search-table
              v-model="baseData.salesmanName"
              searchType="personnel"
              :currentValue="baseData.salesmanName || null"
              :checkRowKeys="[baseData.salesmanNo]"
              @input="setSalesMan"
              :isMultiple="true"
            ></search-table>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.deliveryDepartment')"
            prop="deliveryDepartment"
          >
            <el-input
              :placeholder="this.$t('transportOrderAdd.baseForm.deliveryDepartmentPlaceholder')"
              v-model="baseData.deliveryDepartment"
              clearable
              maxlength="32"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="6">
          <el-form-item
            :label="this.$t('transportOrderAdd.baseForm.customerName')"
            prop="customerName"
          >
            <search-table
              v-model="baseData.customerName"
              searchType="customer"
              :currentValue="baseData.customerName || null"
              :checkRowKeys="[baseData.customerNo]"
              @input="setCustomerName"
              :isMultiple="true"
            ></search-table>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
  import API from '@/api/logisticsCenter/transportOrder';
  import MASTER_API from '@/api/masterData/company.js';
  import SearchTable from '@/components/form-item/search-table';
  import { mapState } from 'vuex';
  // import { resolve, reject } from 'q';

  export default {
    name: 'baseForm',
    props: ['isEdit', 'allDetail', 'status'],
    components: {
      SearchTable,
    },
    mounted() {
      this.judgeDis();
      if (this.status != 0) {
        this.getDeatil();
      }
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo,
      }),
      baseDataRules() {
        // 验证四种单号四选一必填
        let validateNo = (rule, value, callback) => {
          if (
            this.baseData.instructionNo === '' &&
            this.baseData.salesLadingNo === '' &&
            this.baseData.transferSlipNo === '' &&
            this.baseData.otherNo === ''
          ) {
            if (rule.field == 'instructionNo') {
              callback(new Error(this.$t('transportOrderAdd.baseForm.instructionNoPlaceholder')));
            } else if (rule.field == 'salesLadingNo') {
              callback(new Error(this.$t('transportOrderAdd.baseForm.salesLadingNoPlaceholder')));
            } else if (rule.field == 'transferSlipNo') {
              callback(new Error(this.$t('transportOrderAdd.baseForm.transferSlipNoPlaceholder')));
            } else {
              callback(new Error(this.$t('transportOrderAdd.baseForm.otherNoPlaceholder')));
            }
          } else {
            callback();
          }
        };
        return {
          // instructionNo: [{ validator: validateNo, trigger: ["blur", "change"] }],
          // salesLadingNo: [{ validator: validateNo, trigger: ["blur", "change"] }],
          transferSlipNo: [{ validator: validateNo, trigger: ['blur', 'change'] }],
          otherNo: [{ validator: validateNo, trigger: ['blur', 'change'] }],
        };
      },
      department() {
        return {
          apiUrl: MASTER_API.LIST_COMPANY_API,
          apiData: {
            tenantCode: this.userInfo.userInfo.tenantCode,
            adminFlag: this.userInfo.userInfo.adminFlag,
          },
        };
      },
    },
    data() {
      return {
        // 顶部表单
        baseData: {
          instructionNo: '',
          salesLadingNo: '',
          transferSlipNo: '',
          otherNo: '',
          pickupNo: '',
          providerName: '',
          salesmanName: '',
          deliveryDepartment: '',
          customerName: '',
          customerNo: '',
          providerNo: '',
          salesmanNo: '',
        },
        isInstructionNo: true,
        isSalesLadingNo: true,
        isTransferSlipNo: true,
        isOtherNo: true,
        instructionNoLoading: false,
        instructionNoOptions: [], //提货仓库下拉数据
        salesLadingNoLoading: false,
        salesLadingNoOptions: [], //提货仓库下拉数据
        transferSlipNoLoading: false,
        transferSlipNoOptions: [], //提货仓库下拉数据
        otherNoLoading: false,
        otherNoOptions: [], //提货仓库下拉数据
        insDis: false,
        salesDis: false,
        transDis: false,
        otherDis: false,
        oldDis: false,
      };
    },
    methods: {
      judgeDis() {
        if (this.status == '1' || this.status == '5') {
          this.insDis = true;
          this.salesDis = true;
          this.transDis = true;
          this.otherDis = true;
        } else if (this.status == '0') {
          this.insDis =
            this.baseData.salesLadingNo != '' ||
            this.baseData.transferSlipNo != '' ||
            this.baseData.otherNo != '';
          this.salesDis =
            this.baseData.instructionNo != '' ||
            this.baseData.transferSlipNo != '' ||
            this.baseData.otherNo != '';
          this.transDis =
            this.baseData.instructionNo != '' ||
            this.baseData.salesLadingNo != '' ||
            this.baseData.otherNo != '';
          this.otherDis =
            this.baseData.instructionNo != '' ||
            this.baseData.salesLadingNo != '' ||
            this.baseData.transferSlipNo != '';
        } else if (this.status == '2') {
          if (this.oldDis) {
            this.insDis = true;
            this.salesDis = true;
            this.transDis = true;
            this.otherDis = true;
          } else {
            this.insDis =
              this.baseData.salesLadingNo != '' ||
              this.baseData.transferSlipNo != '' ||
              this.baseData.otherNo != '';
            this.salesDis =
              this.baseData.instructionNo != '' ||
              this.baseData.transferSlipNo != '' ||
              this.baseData.otherNo != '';
            this.transDis =
              this.baseData.instructionNo != '' ||
              this.baseData.salesLadingNo != '' ||
              this.baseData.otherNo != '';
            this.otherDis =
              this.baseData.instructionNo != '' ||
              this.baseData.salesLadingNo != '' ||
              this.baseData.transferSlipNo != '';
          }
        }
      },
      setCustomerName(row) {
        this.baseData.customerName = row[0].partnerZhName;
        this.baseData.customerNo = row[0].partnerCode;
      },
      setProviderName(row) {
        this.baseData.providerName = row[0].partnerZhName;
        this.baseData.providerNo = row[0].partnerCode;
      },
      setSalesMan(row) {
        this.baseData.salesmanName = row[0].personName;
        this.baseData.salesmanNo = row[0].partnerCode;
      },
      getDeatil() {
        if (this.status != 0) {
          let baseData = {};
          Object.keys(this.baseData).forEach((item) => {
            baseData[`${item}`] = this.allDetail.delivery[`${item}`] || '';
          });
          this.baseData = baseData;
        }
        if (
          this.baseData.instructionNo != '' ||
          this.baseData.salesLadingNo != '' ||
          this.baseData.transferSlipNo != '' ||
          this.baseData.otherNo != ''
        ) {
          this.oldDis = true;
        } else {
          this.oldDis = false;
        }
        this.changeDeliveryTypeT();
      },
      //详情页不掉提单接口
      changeDeliveryTypeT() {
        let deliveryType = '';
        if (this.baseData.instructionNo != '') {
          deliveryType = '1'; //供应商发货指令
          this.isInstructionNo = true;
          this.isSalesLadingNo = false;
          this.isTransferSlipNo = false;
          this.isOtherNo = false;
        } else if (this.baseData.salesLadingNo != '') {
          deliveryType = '2'; //销售提单
          this.isInstructionNo = false;
          this.isSalesLadingNo = true;
          this.isTransferSlipNo = false;
          this.isOtherNo = false;
        } else if (this.baseData.transferSlipNo != '') {
          deliveryType = '3'; //库存调拨单
          this.isInstructionNo = false;
          this.isSalesLadingNo = false;
          this.isTransferSlipNo = true;
          this.isOtherNo = false;
        } else if (this.baseData.otherNo != '') {
          deliveryType = '4'; //采购或销售退换货
          this.isInstructionNo = false;
          this.isSalesLadingNo = false;
          this.isTransferSlipNo = false;
          this.isOtherNo = true;
        }
        this.judgeDis();
        // // 所有前序单据带过来的详细信息
        // this.getGoodsDetail(deliveryType);
        if (this.baseData.instructionNo == '') {
          this.instructionNoOptions = [];
        } else if (this.baseData.salesLadingNo == '') {
          this.salesLadingNoOptions = [];
        } else if (this.baseData.transferSlipNo == '') {
          this.transferSlipNoOptions = [];
        } else if (this.baseData.otherNo == '') {
          this.otherNoOptions = [];
        }
        //说明填写了其中一种单号,将其他几种单号的必填要求去除
        if (deliveryType == '') {
          this.isInstructionNo = true;
          this.isSalesLadingNo = true;
          this.isTransferSlipNo = true;
          this.isOtherNo = true;
        }
        this.$refs.baseForm.clearValidate();
      },
      //提货仓库下拉数据
      instructionNoRemote(query) {
        if (query != '') {
          const params = {
            instructionNo: query,
          };
          this.$axios.post(API.LIST_INSTRUCTIONNO, params).then((res) => {
            if (0 == res.data.code) {
              this.instructionNoOptions = res.data.data;
            } else {
              this.instructionNoOptions = [];
            }
          });
        } else {
          this.instructionNoOptions = [];
        }
      },
      //销售提单号
      salesLadingNoRemote(query) {
        if (query != '') {
          const params = {
            ladingNo: query,
            ladingStatus: 'TDZT03',
          };
          this.$axios.post(API.LIST_STORAGE_LAGE_PAGE, params).then((res) => {
            if (0 == res.data.code) {
              this.salesLadingNoOptions = res.data.data;
            } else {
              this.salesLadingNoOptions = [];
            }
          });
        } else {
          this.salesLadingNoOptions = [];
        }
      },
      //库存调拨单号下拉
      transferSlipNoRemote(query) {
        if (query != '') {
          const params = {
            allotNo: query,
            // allotStatus: "5"
          };
          this.$axios.post(API.LIST_STORAGE_ALLOTS, params).then((res) => {
            if (0 == res.data.code) {
              this.transferSlipNoOptions = res.data.data;
            } else {
              this.transferSlipNoOptions = [];
            }
          });
        } else {
          this.transferSlipNoOptions = [];
        }
      },
      //其他单号下拉数据
      otherNoRemote(query) {
        if (query != '') {
          const params = {
            returnNo: query,
          };
          this.$axios.post(API.LIST_ORDER_RETURN, params).then((res) => {
            if (0 == res.data.code) {
              this.otherNoOptions = res.data.data;
            } else {
              this.otherNoOptions = [];
            }
          });
        } else {
          this.otherNoOptions = [];
        }
      },
      changeDeliveryType() {
        let deliveryType = '';
        if (this.baseData.instructionNo != '') {
          deliveryType = '1'; //供应商发货指令
          this.isInstructionNo = true;
          this.isSalesLadingNo = false;
          this.isTransferSlipNo = false;
          this.isOtherNo = false;
        } else if (this.baseData.salesLadingNo != '') {
          deliveryType = '2'; //销售提单
          this.isInstructionNo = false;
          this.isSalesLadingNo = true;
          this.isTransferSlipNo = false;
          this.isOtherNo = false;
        } else if (this.baseData.transferSlipNo != '') {
          deliveryType = '3'; //库存调拨单
          this.isInstructionNo = false;
          this.isSalesLadingNo = false;
          this.isTransferSlipNo = true;
          this.isOtherNo = false;
        } else if (this.baseData.otherNo != '') {
          deliveryType = '4'; //采购或销售退换货
          this.isInstructionNo = false;
          this.isSalesLadingNo = false;
          this.isTransferSlipNo = false;
          this.isOtherNo = true;
        }
        this.judgeDis();
        // 所有前序单据带过来的详细信息
        this.getGoodsDetail(deliveryType);
        if (this.baseData.instructionNo == '') {
          this.instructionNoOptions = [];
        } else if (this.baseData.salesLadingNo == '') {
          this.salesLadingNoOptions = [];
        } else if (this.baseData.transferSlipNo == '') {
          this.transferSlipNoOptions = [];
        } else if (this.baseData.otherNo == '') {
          this.otherNoOptions = [];
        }
        //说明填写了其中一种单号,将其他几种单号的必填要求去除
        if (deliveryType == '') {
          this.isInstructionNo = true;
          this.isSalesLadingNo = true;
          this.isTransferSlipNo = true;
          this.isOtherNo = true;
        }
        this.$refs.baseForm.clearValidate();
      },
      getGoodsDetail(deliveryType) {
        // list中放商品行信息
        // detail中放form表单的相关信息
        let obj = {
          deliveryType,
        };
        if (deliveryType) {
          // 发货指令号
          if (deliveryType == '1') {
            let list = [];
            this.$axios
              .get(`${API.GET_SHIPPING_INSTRUCTION}/${this.baseData.instructionNo}`)
              .then((res) => {
                if (res.data.code == 0) {
                  if (
                    res.data.data.storageInstructionDetails &&
                    res.data.data.storageInstructionDetails.length != 0
                  ) {
                    res.data.data.storageInstructionDetails.map((item) => {
                      list.push({
                        ...item,
                        providerName: res.data.data.partnerName,
                      });
                    });
                  }
                  obj['list'] = list;
                  let detail = {
                    providerNo: res.data.data.supplierNo || '',
                    providerName: res.data.data.supplierName || '',
                    salesmanNo: res.data.data.salesmanNo || '',
                    salesmanName: res.data.data.salesmanName || '',
                    deliveryDepartment: res.data.data.instructionDepartmentName || '',
                    pickupStorageNo: res.data.data.deliverFromStorageNo || '',
                    pickupStorageName: res.data.data.deliverFromStorageName || '',
                    pickupStorageAddress: res.data.data.deliverFromAddress || '',
                    pickupContactPerson: res.data.data.shippingContactPerson || '',
                    pickupContactTelephone: res.data.data.shippingContact || '',
                    shiptoStorageNo: res.data.data.deliverToStorageNo || '',
                    shiptoStorageName: res.data.data.deliverToStorageName || '',
                    shiptoFlow: res.data.data.flowDirection || '',
                  };
                  Promise.all([
                    this.searchWarehouse(res.data.data.deliverFromStorageNo),
                    this.searchWarehouse(res.data.data.deliverToStorageNo),
                  ]).then((res) => {
                    if (res[0].length) {
                      detail.pickupStorageTelephone = res[0][0].contactTelephone;
                    }
                    if (res[1].length) {
                      detail.shiptoStorageAddress = res[1][0].storageAddress;
                      detail.shiptoStorageTelephone = res[1][0].contactTelephone;
                    }
                    obj.detail = detail;
                    this.getChooseDetail(obj);
                    this.$emit('getDeliveryType', obj);
                  });
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
          } else if (deliveryType == '2') {
            // 销售提单号
            this.$axios
              .post(`${API.GET_STORAGE_LADE_DETAIL}`, {
                ladingNo: this.baseData.salesLadingNo,
              })
              .then((res) => {
                if (res.data.code == 0) {
                  let detail = {
                    providerNo: res.data.data.supplierNo,
                    providerName: res.data.data.supplierName,
                    salesmanNo: res.data.data.ladingSalesmanNo,
                    salesmanName: res.data.data.ladingSalesmanName,
                    deliveryDepartment: res.data.data.ladingBusinessDepartmentName,
                    customerNo: res.data.data.customerNo,
                    customerName: res.data.data.customerName,
                    pickupStorageNo: res.data.data.storageNo,
                    pickupStorageName: res.data.data.storageName,
                    shiptoStorageAddress: res.data.data.deliveryAddress,
                    shiptoContactPerson: res.data.data.receiver,
                    shiptoContactTelephone: res.data.data.receiverPhone,
                  };
                  obj['list'] = res.data.data.storageLadingPickingList;
                  if (res.data.data.storageNo) {
                    Promise.resolve(this.searchWarehouse(res.data.data.storageNo)).then((res) => {
                      if (res) {
                        detail.pickupStorageAddress = res[0].storageAddress;
                        detail.pickupStorageTelephone = res[0].contactTelephone;
                        obj.detail = detail;
                        this.getChooseDetail(obj);
                        this.$emit('getDeliveryType', obj);
                      }
                    });
                  }
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
          } else if (deliveryType == '3') {
            this.$axios
              .get(API.QUERY_DETAIL_BY_ALLOTNO, {
                allotNo: this.baseData.transferSlipNo,
              })
              .then((res) => {
                if (res.data.code == 0) {
                  obj['list'] = res.data.data.storageAllotDetailVOs;
                  let detail = {
                    deliveryDepartment: res.data.data.allotDepartmentName || '',
                    pickupStorageNo: res.data.data.allotOutStorageNo || '',
                    pickupStorageName: res.data.data.allotOutStorage || '',
                    shiptoStorageNo: res.data.data.allotInStorageNo || '',
                    shiptoStorageName: res.data.data.allotInStorage || '',
                  };
                  Promise.all([
                    this.searchWarehouse(res.data.data.allotOutStorageNo),
                    this.searchWarehouse(res.data.data.allotInStorageNo),
                  ]).then((res) => {
                    if (res[0].length) {
                      detail.pickupStorageAddress = res[0][0].storageAddress;
                      detail.pickupStorageTelephone = res[0][0].contactTelephone;
                    }
                    if (res[1].length) {
                      detail.shiptoStorageAddress = res[1][0].storageAddress;
                      detail.shiptoStorageTelephone = res[1][0].contactTelephone;
                    }
                    obj.detail = detail;
                    this.getChooseDetail(obj);
                    this.$emit('getDeliveryType', obj);
                  });
                }
              });
          } else {
            this.$axios
              .post(API.LIST_ORDER_RETURN, {
                returnNo: this.baseData.otherNo,
              })
              .then((res) => {
                if (res.data.code == 0) {
                  obj['list'] = res.data.data;
                  if (res.data.data.length) {
                    let detail = {
                      providerNo: res.data.data[0].partnerCode || '',
                      providerName: res.data.data[0].partnerName || '',
                      salesmanNo: res.data.data[0].returnSalesmanCode || '',
                      salesmanName: res.data.data[0].returnSalesmanName || '',
                      deliveryDepartment: res.data.data[0].returnDepartmentName || '',
                      customerNo: res.data.data[0].purchaseUnitNo || '',
                      customerName: res.data.data[0].purchaseUnitName || '',
                      returnSource: res.data.data[0].returnSource,
                      pickupStorageAddress: res.data.data[0].deliveryAddress || '',
                      pickupStorageNo: res.data.data[0].outboundStorageNo || '',
                      pickupStorageName: res.data.data[0].outboundStorageName || '',
                      shiptoStorageNo: res.data.data[0].inboundStorageNo || '',
                      shiptoStorageName: res.data.data[0].inboundStorageName || '',
                    };
                    Promise.all([
                      this.searchWarehouse(res.data.data[0].outboundStorageNo),
                      this.searchWarehouse(res.data.data[0].inboundStorageNo),
                    ]).then((res) => {
                      if (res[0].length) {
                        if (detail.returnSource == '02') {
                          detail.pickupStorageAddress = res[0][0].storageAddress;
                          detail.pickupStorageTelephone = res[0][0].contactTelephone;
                        }
                      }
                      if (res[1].length) {
                        detail.shiptoStorageAddress = res[1][0].storageAddress;
                        detail.shiptoStorageTelephone = res[1][0].contactTelephone;
                      }
                      obj.detail = detail;
                      this.getChooseDetail(obj);
                      this.$emit('getDeliveryType', obj);
                    });
                  }
                } else {
                  this.$message({
                    showClose: true,
                    message: res.data.msg,
                    type: 'error',
                  });
                }
              });
          }
        } else {
          this.getChooseDetail(obj);
          this.$emit('getDeliveryType', obj);
        }
      },
      // 查询仓库信息
      searchWarehouse(storageCode) {
        return new Promise((resolve, reject) => {
          const query = {
            storageCode,
            adminFlag: this.userInfo.userInfo.adminFlag,
            //已生效的仓库
            currentStatus: 'ZT03',
          };
          this.$axios.post(MASTER_API.GET_STORAGE_LIST, query).then((res) => {
            if (0 == res.data.code) {
              resolve(res.data.data);
            } else {
              reject();
            }
          });
        });
      },
      // 选择各种单号后带出的详情
      getChooseDetail(obj) {
        let baseData = {};
        if (obj.detail) {
          Object.keys(this.baseData).forEach((item) => {
            baseData[`${item}`] = obj.detail[`${item}`] || this.baseData[`${item}`];
          });
        } else {
          baseData = this.baseData;
          baseData.providerNo = '';
          baseData.providerName = '';
          baseData.salesmanNo = '';
          baseData.salesmanName = '';
          baseData.deliveryDepartment = '';
          baseData.customerNo = '';
          baseData.customerName = '';
        }
        this.baseData = baseData;
      },
      // 返回数据
      exportChildData(btnType) {
        if (btnType == '4') {
          let sign = false;
          this.$refs.baseForm.validate((valid) => {
            if (valid) {
              sign = true;
            } else {
              sign = false;
            }
          });
          return sign ? this.baseData : false;
        } else {
          return this.baseData;
        }
      },
    },
  };
</script>
<style lang="scss" scoped>
  .baseForm .widthStyle {
    width: 100%;
  }
  .el-collapse-item__wrap {
    overflow: inherit !important;
  }
</style>
